import { render, staticRenderFns } from "./CreateChapterModal.vue?vue&type=template&id=63cf9841&scoped=true"
import script from "./CreateChapterModal.vue?vue&type=script&lang=js"
export * from "./CreateChapterModal.vue?vue&type=script&lang=js"
import style0 from "./CreateChapterModal.vue?vue&type=style&index=0&id=63cf9841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf9841",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSelect,VSwitch,VTextField})
